
export const content = {
    en: {
      title: "Information on Memory Institutions and Other Information Resources",
      wwi: {
        title: "FIRST WORLD WAR",
        subtitle: "Information on Latvian residents who served in the Russian (imperial) army during World War I and as part of the Red Army during the Russian Civil War",
        institutions: [
          {
            name: "LATVIAN WAR MUSEUM",
            description: "lists of Latvian riflemen",
            address: "Smilšu Street 20, Riga",
            phone: "(+371) 63 616 238",
            email: "pasts@karamuzejs.lv",
            website: "http://www.karamuzejs.lv"
          },
          {
            name: "LATVIA NATIONAL ARCHIVES",
            description: "Latvian State Historical Archive (LNA LVVA) – questionnaires of volunteer Latvian riflemen, letters about transfer to rifle battalions",
            address: "Slokas Street 16, Riga",
            phone: "(+371) 67 613 118",
            email: "lvva@arhivi.gov.lv",
            website: "https://www.arhivi.gov.lv/lv/strukturvieniba/latvijas-valsts-vestures-arhivs",
            searchEngine: "https://eresursi.arhivi.gov.lv/CoreBusiness/DescriptionUnits/F.PRP.VNB.A.MKL.aspx",
            collections: ["P-1036. fund – Latvian Rifle Battalion Organization Committee"]
          }
        ],
        onlineLists: {
          title: "Lists of soldiers available online, online search engines, useful links",
          items: [
            {
              name: "List of Latvian Riflemen (comp. – Jānis Hartmanis)",
              url: "https://latviesustrelniekusaraksts.lv/Saraksts/index.html"
            },
            {
              name: "Search engine for soldiers who served in the Russian (imperial) armies",
              url: "https://gwar.mil.ru/heroes/"
            },
            {
              name: "Jānis Hartmanis' books on the history of the Latvian riflemen",
              url: "https://latviesustrelniekusaraksts.lv/Kaujas_darbiba/index.html"
            },
            {
              name: "Memories of riflemen's families",
              url: "https://www.dveseluputenis.lv/lv/dzivas-atminas/"
            },
            {
              name: "List of fallen, wounded and missing riflemen at Tīnūži Manor",
              url: "https://www.ogrenet.lv/kultura/tinuzos-jauns-vides-objekts-un-digitalais-stends-4949"
            },
            {
              name: "Books on the history of the Latvian riflemen",
              url: "https://latviesustrelniekusaraksts.lv/Gramatas.html"
            }
          ]
        }
      },
      wwii: {
        title: "SECOND WORLD WAR",
        subtitle: "Information about the Latvian service of the population in the military formations of Nazi Germany (Latvian Legion, etc.) during World War II",
        institutions: [
          {
            name: "LATVIAN WAR MUSEUM",
            address: "Smilšu Street 20, Riga",
            phone: "(+371) 63 616 238",
            email: "pasts@karamuzejs.lv",
            website: "http://www.karamuzejs.lv"
          },
          {
            name: "LATVIA NATIONAL ARCHIVES",
            sections: [
              {
                subtitle: "Latvian State Historical Archive (LNA LVVA) – about service in the Latvian Legion",
                address: "Slokas Street 16, Riga",
                phone: "(+371) 67 613 118",
                email: "lvva@arhivi.gov.lv",
                website: "https://www.arhivi.gov.lv/lv/strukturvieniba/latvijas-valsts-vestures-arhivs",
                searchEngine: "https://eresursi.arhivi.gov.lv/CoreBusiness/DescriptionUnits/F.PRP.VNB.A.MKL.aspx",
                collections: [
                  "Col. P-180. - SS Troops Administration \"Ostland\" supply officer (social insurance documentation of those mobilized in the legion, etc.)",
                  "Col. 296 - 15th SS Grenadier Division (Latvian No. 1) headquarters (the fund description provides information on the mentioned persons, mainly officers)"
                ]
              },
              {
                subtitle: "Latvian State Archives (LVA) - passports of legionnaires / about being in Western prisoner-of-war camps / about being in Soviet filtration camps / about those tried by the Soviet authorities",
                address: "Bezdelīgu iela 1, Riga",
                phone: "(+371) 67 462 317",
                email: "lva@arhivi.gov.lv",
                website: "https://www.arhivi.gov.lv/lv/strukturvieniba/latvijas-valsts-arhivs",
                searchEngine: "http://www.archiv.org.lv/index.php?id=9099",
                collections: [
                  "Col. 2416 - Personal documents of Latvian legionnaires / Daugava Hawks collection (Great Britain)",
                  "Col. 2395 - Hoover Institution (USA) archive collection",
                  "Col. 1821 - Personal files of Latvian residents imprisoned in USSR checkpoints and camps",
                  "Col. 1986 - Criminal cases of persons accused of especially dangerous anti-state crimes by the State Security Committee (KDK) of the Latvian SSR"
                ]
              }
            ]
          },
          {
            name: "GERMAN FEDERAL ARCHIVES (BUNDESARCHIV)",
            description: "information on service / on killed or missing in action",
            address: "Eichborndamm 179, D-13403 Berlin, Deutschland",
            phone: "+49 (030) 41904-0",
            email: "poststelle-pa@bundesarchiv.de",
            website: "https://ej.uz/bundesarchiv_dienstelle"
          }
        ],
        missingPersons: {
          title: "Where to search for missing persons (including soldiers)?",
          institutions: [
            {
              name: "LATVIA RED CROSS",
              note: "(first contact the Latvian Red Cross, then the German Red Cross)",
              address: "Gaiziņa Street 7, Riga, SC \"Gaiziņš\"",
              phone: "+371 26143344",
              email: "meklesana@redcross.lv",
              website: "https://www.redcross.lv/darbibas-jomas/meklesanas-dienests/"
            },
            {
              name: "GERMAN RED CROSS",
              fullName: "Deutsches Rotes Kreuz - Suchdienst Hamburg",
              address: "Amandastraße 74, 20357 Hamburg, Deutschland",
              email: "auskunft@drk-sdhh.de",
              website: "https://www.drk-suchdienst.de/en/how-we-help/tracing/second-worldwar/online-tracing-request-second-world-war/"
            },
            {
              name: "AROLSEN ARCHIVE",
              description: "on missing persons / victims of Nazi repression / forced laborers / displaced persons, etc.",
              fullName: "Arolsen Archives (formerly International Tracing Service)",
              address: "Große Allee 5 – 9, 34454 Bad Arolsen, Germany",
              websiteForm: "https://arolsen-archives.org/en/searchexplore/inquiries/submit-inquiry/",
              searchEngine: "https://collections.arolsen-archives.org/en/search"
            }
          ]
        },
        militaryUnits: {
          title: "Where to research German military units?",
          institutions: [
            {
              name: "GERMAN FEDERAL ARCHIVES MILITARY ARCHIVES",
              description: "(history of military units, orders, etc.)",
              fullName: "Bundesarchiv Abteilung Militärarchiv (Abt. MA)",
              address: "Wiesentalstraße 10, 79115 Freiburg"
            },
            {
              name: "NATIONAL ARCHIVES OF USA",
              email: "inquire@nara.gov",
              website: "https://www.archives.gov/",
              searchEngine: "https://catalog.archives.gov/"
            }
          ]
        },
        sovietService: {
          title: "Information about the Latvian service in the military formations of the Soviet Union (Red Army, etc.)",
          fallenMissing: {
            title: "Fallen / missing soldiers of the 130th Latvian Rifle Corps:",
            items: [
              {
                name: "Russian Society in Latvia",
                description: "information about the Soviet Brotherhood cemeteries in Latvia, those buried there",
                url: "http://voin.russkie.org.lv/vov_bkm.php"
              },
              {
                name: "Association of the 130th Latvian Rifle Corps and Partisan Brigades of the Red Army",
                description: "MEMORIAL BOOK. 1941–1945. Dedicated to the 130th Latvian Rifle Corps (2012), information on 19,241 fallen and missing, their burial places"
              }
            ]
          },
          searchEngines: {
            title: "Online search engines for Red Army soldiers:",
            urls: [
              "https://pamyat-naroda.ru/heroes/",
              "https://obd-memorial.ru/html/",
              "https://podvignaroda.ru/?#tab=navPeople_search"
            ]
          }
        },
        onlineResources: {
          title: "Online lists of soldiers, online search engines, useful links",
          items: [
            {
              name: "Red Army soldiers who served, were awarded, were wounded, fell and are missing",
              url: "https://pamyat-naroda.ru/"
            },
            {
              name: "Soviet prisoners of war in Germany",
              url: "https://en.stsg.de/cms/dokstelle/search-online-archives/soviet-prisoners-war"
            },
            {
              name: "Jānis Melderis \"The fate of 6,000 Latvian officers during the Second World War\" (2017)",
              url: "http://virsnieki.lv/wp/wp-content/uploads/2017/01/J_MELDERIS_Latv_virsnieki.pdf"
            },
            {
              name: "Lists of those buried in Latvian cemeteries",
              url: "https://cemety.lv/"
            },
            {
              name: "Lists of fallen and missing Latvian legionnaires engraved on the memorial wall of the Lestene Brothers' Cemetery (with last service unit, service rank)"
            },
            {
              name: "Collection of documents and memories \"Latviešu karavīrs Otrā pasaules kara laikā\" in 11 volumes",
              url: "https://dvcv.org.lv/latviesu_karavirs_otra_pasaules_kara_laika"
            },
            {
              name: "Search the National Archives of Latvia",
              url: "https://eresursi.arhivi.gov.lv/CoreBusiness/DescriptionUnits/F.PRP.VNB.A.MKL.aspx"
            },
            {
              name: "Search the Latvian National Archives of Latvia in the archive",
              url: "http://www.archiv.org.lv/index3.php?id=9099"
            },
            {
              name: "Search in the Arolsen archive",
              url: "https://collections.arolsen-archives.org/en/search"
            },
            {
              name: "Lists of soldiers, etc. found by the search unit \"Zvaigzne\"",
              url: "https://www.mvz.lv/?page_id=2"
            },
            {
              name: "Committee of fraternal graves (you can inquire about graves in Latvia, the fallen)",
              url: "http://www.bkkomiteja.lv/kontakti/"
            },
            {
              name: "German People's Association for the Care of the Graves of German War Fallen (Volksbund Deutsche Kriegsgräberfürsorge e.V) online search engine",
              url: "https://www.volksbund.de/en/erinnern-gedenken/gravesearch-online"
            }
          ]
        }
      },
      preparedBy: "Prepared by: © Jānis Tomaševskis, Latvian War Museum"
    },
    lv: {
      title: "Informācija par atmiņu institūcijām un citiem informācijas resursiem",
      wwi: {
        title: "PIRMAIS PASAULES KARŠ",
        subtitle: "Informācija par Latvijas iedzīvotājiem, kas dienējuši Krievijas (impērijas) armijā Pirmā pasaules kara laikā un Sarkanās armijas sastāvā Krievijas Pilsoņu karā",
        institutions: [
          {
            name: "LATVIJAS KARA MUZEJS",
            description: "latviešu strēlnieku saraksti",
            address: "Smilšu iela 20, Rīga",
            phone: "(+371) 63 616 238",
            email: "pasts@karamuzejs.lv",
            website: "http://www.karamuzejs.lv"
          },
          {
            name: "LATVIJAS NACIONĀLAIS ARHĪVS",
            description: "Latvijas Valsts vēstures arhīvs (LNA LVVA) – brīvprātīgo latviešu strēlnieku anketas, vēstules par pārcelšanu uz strēlnieku bataljoniem",
            address: "Slokas iela 16, Rīga",
            phone: "(+371) 67 613 118",
            email: "lvva@arhivi.gov.lv",
            website: "https://www.arhivi.gov.lv/lv/strukturvieniba/latvijas-valsts-vestures-arhivs",
            searchEngine: "https://eresursi.arhivi.gov.lv/CoreBusiness/DescriptionUnits/F.PRP.VNB.A.MKL.aspx",
            collections: ["P-1036. fonds – Latviešu strēlnieku bataljonu organizācijas komiteja"]
          }
        ],
        onlineLists: {
          title: "Tiešsaistē pieejami karavīru saraksti, online meklētāji, noderīgas saites",
          items: [
            {
              name: "Latviešu strēlnieku saraksts (sast. – Jānis Hartmanis)",
              url: "https://latviesustrelniekusaraksts.lv/Saraksts/index.html"
            },
            {
              name: "Krievijas (impērijas) armijā dienējušo karavīru meklētājs",
              url: "https://gwar.mil.ru/heroes/"
            },
            {
              name: "Jāņa Hartmaņa grāmatas par latviešu strēlnieku vēsturi",
              url: "https://latviesustrelniekusaraksts.lv/Kaujas_darbiba/index.html"
            },
            {
              name: "Strēlnieku dzimtu atmiņu stāsti",
              url: "https://www.dveseluputenis.lv/lv/dzivas-atminas/"
            },
            {
              name: "Kritušo, ievainoto un bez vēsts pazudušo strēlnieku saraksts pie Tīnūžu muižas",
              url: "https://www.ogrenet.lv/kultura/tinuzos-jauns-vides-objekts-un-digitalais-stends4949"
            },
            {
              name: "Grāmatas par latviešu strēlnieku vēsturi",
              url: "https://latviesustrelniekusaraksts.lv/Gramatas.html"
            }
          ]
        }
      },
      wwii: {
        title: "OTRAIS PASAULES KARŠ",
        subtitle: "Informācija par Latvijas iedzīvotāju dienestu nacistiskās Vācijas militārajos formējumos (Latviešu leģionā u. c.) Otrā pasaules kara laikā",
        institutions: [
          {
            name: "LATVIJAS KARA MUZEJS",
            address: "Smilšu iela 20, Rīga",
            phone: "(+371) 63 616 238",
            email: "pasts@karamuzejs.lv",
            website: "http://www.karamuzejs.lv"
          },
          {
            name: "LATVIJAS NACIONĀLAIS ARHĪVS",
            sections: [
              {
                subtitle: "Latvijas Valsts vēstures arhīvs (LNA LVVA) – par dienestu Latviešu leģionā",
                address: "Slokas iela 16, Rīga",
                phone: "(+371) 67 613 118",
                email: "lvva@arhivi.gov.lv",
                website: "https://www.arhivi.gov.lv/lv/strukturvieniba/latvijas-valsts-vestures-arhivs",
                searchEngine: "https://eresursi.arhivi.gov.lv/CoreBusiness/DescriptionUnits/F.PRP.VNB.A.MKL.aspx",
                collections: [
                  "P-180. fonds - SS karaspēka pārvaldes \"Ostland\" apgādības virsnieks (leģionā mobilizēto sociālās apdrošināšanas dokumentācija u. c.)",
                  "296. fonds - 15. ieroču SS grenadieru divīzijas (latviešu Nr. 1) štābs (fonda aprakstā var iepazīties ar pieminētajām personām, galvenokārt, virsniekiem)"
                ]
              },
              {
                subtitle: "Latvijas Valsts arhīvs (LVA) – leģionāru pases / par atrašanos Rietumu karagūstekņu nometnēs / par atrašanos padomju filtrācijas nometnēs / par padomju varas tiesātajiem",
                address: "Bezdelīgu iela 1, Rīga",
                phone: "(+371) 67 462 317",
                email: "lva@arhivi.gov.lv",
                website: "https://www.arhivi.gov.lv/lv/strukturvieniba/latvijas-valsts-arhivs",
                searchEngine: "http://www.archiv.org.lv/index.php?id=9099",
                collections: [
                  "2416. fonds - Latviešu leģionāru personu dokumenti / Daugavas Vanagu kolekcija (Lielbritānija)",
                  "2395. fonds - Hūvera institūta (ASV) arhīva kolekcija",
                  "1821. fonds - PSRS Pārbaudes filtrācijas punktos un nometnēs ieslodzīto Latvijas iedzīvotāju personas lietas",
                  "1986. fonds - Latvijas PSR Valsts drošības komitejas (VDK) par sevišķi bīstamiem pretvalstiskiem noziegumiem apsūdzēto personu krimināllietas"
                ]
              }
            ]
          },
          {
            name: "VĀCIJAS FEDERĀLAIS ARHĪVS (BUNDESARCHIV)",
            description: "informācija par dienestu / par krišanu vai pazušanu bez vēsts",
            address: "Eichborndamm 179, D-13403 Berlin, Deutschland",
            phone: "+49 (030) 41904-0",
            email: "poststelle-pa@bundesarchiv.de",
            website: "https://ej.uz/bundesarchiv_dienstelle"
          }
        ],
        missingPersons: {
          title: "Kur meklēt pazudušas personas (tostarp, karavīrus)?",
          institutions: [
            {
              name: "LATVIJAS SARKANAIS KRUSTS",
              note: "(vispirms jāvēršas Latvijas SK, pēc tam Vācijas SK)",
              address: "Gaiziņa iela 7, Rīga, SC \"Gaiziņš\"",
              phone: "+371 26143344",
              email: "meklesana@redcross.lv",
              website: "https://www.redcross.lv/darbibas-jomas/meklesanas-dienests/"
            },
            {
              name: "VĀCIJAS SARKANAIS KRUSTS",
              fullName: "Deutsches Rotes Kreuz - Suchdienst Hamburg",
              address: "Amandastraße 74, 20357 Hamburg, Deutschland",
              email: "auskunft@drk-sdhh.de",
              website: "https://www.drk-suchdienst.de/en/how-we-help/tracing/second-worldwar/online-tracing-request-second-world-war/"
            },
            {
              name: "AROLSENAS ARHĪVS",
              description: "par pazudušām personām / nacistu represijās cietušajiem / piespiedu darba strādniekiem / pārvietotajām personām (displaced persons) u. c.",
              fullName: "Arolsen Archives (iepriekš – International Tracing Service)",
              address: "Große Allee 5 – 9, 34454 Bad Arolsen, Deutschland",
              websiteForm: "https://arolsen-archives.org/en/searchexplore/inquiries/submit-inquiry/",
              searchEngine: "https://collections.arolsen-archives.org/en/search"
            }
          ]
        },
        militaryUnits: {
          title: "Kur pētīt vācu militārās vienības?",
          institutions: [
            {
              name: "VĀCIJAS FEDERĀLĀ ARHĪVA MILITĀRAIS ARHĪVS",
              description: "(militāro vienību vēsture, pavēles utt.)",
              fullName: "Bundesarchiv Abteilung Militärarchiv (Abt. MA)",
              address: "Wiesentalstraße 10, 79115 Freiburg, Deutschland",
              email: "militaerarchiv@bundesarchiv.de",
              website: "https://ej.uz/bundesarhivs"
            },
            {
              name: "ASV NACIONĀLAIS ARHĪVS (NARA)",
              email: "inquire@nara.gov",
              website: "https://www.archives.gov/",
              searchEngine: "https://catalog.archives.gov/"
            }
          ]
        },
        sovietService: {
          title: "Informācija par Latvijas iedzīvotāju dienestu Padomju Savienības militārajos formējumos (Sarkanajā armijā u. c.)",
          fallenMissing: {
            title: "Kritušie / bez vēsts pazudušie 130. latviešu strēlnieku korpusa karavīri:",
            items: [
              {
                name: "Krievu biedrība Latvijā",
                description: "informācija par padomju Brāļu kapiem Latvijā, tur apbedītajiem",
                url: "http://voin.russkie.org.lv/vov_bkm.php"
              },
              {
                name: "Sarkanās armijas 130. latviešu strēlnieku korpusa un partizānu brigāžu apvienība",
                description: "PIEMIŅAS GRĀMATA. 1941–1945. Veltīta 130. latviešu strēlnieku korpusam (2012), informācija par 19 241 kritušajiem un bez vēsts pazudušajiem, to apbedījuma vietām"
              }
            ]
          },
          searchEngines: {
            title: "Sarkanās armijas karavīru tiešsaistes meklētāji:",
            urls: [
              "https://pamyat-naroda.ru/heroes/",
              "https://obd-memorial.ru/html/",
              "https://podvignaroda.ru/?#tab=navPeople_search"
            ]
          }
        },
        onlineResources: {
          title: "Tiešsaistē pieejami karavīru saraksti, online meklētāji, noderīgas saites",
          items: [
            {
              name: "Sarkanajā armijā dienējušie, apbalvotie, ievainotie, kritušie un bez vēsts pazudušie karavīri",
              url: "https://pamyat-naroda.ru/"
            },
            {
              name: "Padomju karagūstekņi Vācijā",
              url: "https://en.stsg.de/cms/dokstelle/search-online-archives/soviet-prisoners-war"
            },
            {
              name: "Jānis Melderis \"6 000 latviešu virsnieku likteņi Otrā pasaules kara gados\" (2017)",
              url: "http://virsnieki.lv/wp/wp-content/uploads/2017/01/J_MELDERIS_Latv_virsnieki.pdf"
            },
            {
              name: "Latvijas kapsētās apbedīto saraksti",
              url: "https://cemety.lv/"
            },
            {
              name: "Lestenes brāļu kapu piemiņas sienā iegravēto kritušo un bez vēsts pazudušo latviešu leģionāru saraksti (ar pēdējo dienesta vienību, dienesta pakāpi)"
            },
            {
              name: "Dokumentu un atmiņu krājums \"Latviešu karavīrs Otrā pasaules kara laikā\" 11 sējumi",
              url: "https://dvcv.org.lv/latviesu_karavirs_otra_pasaules_kara_laika"
            },
            {
              name: "Meklēt Latvijas Nacionālajā arhīvā",
              url: "https://eresursi.arhivi.gov.lv/CoreBusiness/DescriptionUnits/F.PRP.VNB.A.MKL.aspx"
            },
            {
              name: "Meklēt Latvijas Nacionālā arhīva Latvijas Valsts arhīvā",
              url: "http://www.archiv.org.lv/index3.php?id=9099"
            },
            {
              name: "Meklēt Arolsenas arhīvā",
              url: "https://collections.arolsen-archives.org/en/search"
            },
            {
              name: "Meklēšanas vienības \"Zvaigzne\" atrasto karavīru u. c. saraksti",
              url: "https://www.mvz.lv/?page_id=2"
            },
            {
              name: "Brāļu kapu komiteja (var interesēties par kapiem Latvijā, kritušajiem)",
              url: "http://www.bkkomiteja.lv/kontakti/"
            },
            {
              name: "Vācijas Tautas apvienība karā kritušo vāciešu kapu aprūpei (Volksbund Deutsche Kriegsgräberfürsorge e.V) online meklētājs",
              url: "https://www.volksbund.de/en/erinnern-gedenken/gravesearch-online"
            }
          ]
        }
      },
      preparedBy: "Sagatavoja: © Jānis Tomaševskis, Latvijas Kara muzejs"
    }
  };